"use strict";

exports.__esModule = true;
exports.default = exports.RadioButtonQuestion = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _button = require("@jsluna/button");

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var mapOptionsToRadioButtonField = function mapOptionsToRadioButtonField(options) {
  return [].concat(options).map(function (x) {
    return {
      value: x.title,
      label: x.title
    };
  });
};

var RadioButtonQuestion = function RadioButtonQuestion(_ref) {
  var id = _ref.id,
      name = _ref.name,
      editable = _ref.editable,
      initialOptions = _ref.initialOptions,
      isRequired = _ref.isRequired,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      onRadioButtonOptionUpdated = _ref.onRadioButtonOptionUpdated;

  var _useState = (0, _react.useState)(initialOptions),
      radioButtonOptions = _useState[0],
      setRadioButtonOptions = _useState[1];

  var _useState2 = (0, _react.useState)(!isRequired),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      inputValue = _useState3[0],
      setInputValue = _useState3[1];

  var onRadioButtonChange = function onRadioButtonChange(e) {
    var newIsValid = !(isRequired && e.target.value.length === 0);
    setIsValid(newIsValid);
    onClick(e.target.value);
  };

  var onRemoveClick = function onRemoveClick(x) {
    var newOptions = radioButtonOptions.filter(function (y) {
      return y.number !== x;
    });
    newOptions.map(function (y, i) {
      return y.number = i + 1;
    });
    setRadioButtonOptions(newOptions);
    onRadioButtonOptionUpdated(newOptions);
  };

  var addItem = function addItem() {
    if (radioButtonOptions.length < 10 && inputValue !== '') {
      var newOptions = [].concat(radioButtonOptions, [{
        number: radioButtonOptions.length + 1,
        title: inputValue,
        value: inputValue
      }]);
      newOptions.map(function (x, i) {
        return x.number = i + 1;
      });
      setRadioButtonOptions(newOptions);
      setInputValue('');
      onRadioButtonOptionUpdated(newOptions);
    }
  };

  var handleInput = function handleInput(e) {
    setInputValue(e.target.value);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: id
  }, editable ? radioButtonOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex'
      },
      key: option.number
    }, /*#__PURE__*/_react.default.createElement(_form.RadioButton, {
      disabled: disabled,
      label: option.title,
      name: name
    }), /*#__PURE__*/_react.default.createElement(_button.Button, {
      style: {
        position: 'absolute',
        right: -80
      },
      id: "removeBtn",
      type: "button",
      onClick: function onClick() {
        return onRemoveClick(option.number);
      }
    }, "Remove"));
  }) : disabled ? radioButtonOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex'
      },
      key: option.number
    }, /*#__PURE__*/_react.default.createElement(_form.RadioButton, {
      style: {
        display: 'absolute'
      },
      disabled: disabled,
      label: option.title,
      name: name
    }));
  }) : /*#__PURE__*/_react.default.createElement(_form.RadioButtonField, {
    onChange: function onChange(e) {
      return onRadioButtonChange(e);
    },
    error: isValid ? '' : _constants.VALIDATION_ERROR,
    name: name,
    options: mapOptionsToRadioButtonField(radioButtonOptions)
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: editable ? {
      display: 'flex'
    } : {
      display: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_form.TextInput, {
    disabled: radioButtonOptions.length === 10,
    name: name,
    onKeyUp: function onKeyUp(e) {
      if (e.which === 13) {
        addItem();
      }
    },
    value: inputValue,
    maxLength: 250,
    placeholder: "Enter another option",
    onChange: function onChange(e) {
      handleInput(e);
    }
  }), /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: radioButtonOptions.length === 10,
    onClick: function onClick() {
      addItem();
    }
  }, "Add")));
};

exports.RadioButtonQuestion = RadioButtonQuestion;
RadioButtonQuestion.propTypes = {
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  editable: _propTypes.default.bool.isRequired,
  initialOptions: _propTypes.default.array.isRequired,
  isRequired: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onRadioButtonOptionUpdated: _propTypes.default.func
};
RadioButtonQuestion.defaultProps = {
  isRequired: false,
  disabled: false,
  onClick: function onClick() {},
  onRadioButtonOptionUpdated: function onRadioButtonOptionUpdated() {}
};
var _default = RadioButtonQuestion;
exports.default = _default;